export default __webpack_public_path__ + "static/media/022-wristwatch.ef22a5da.svg";